import * as z from 'zod'

export const applicationPipelineReportSchema = z.object({
  status: z.string().optional(),
  page: z.number().int().positive().optional(),
  size: z.number().int().positive().optional()
})
